import { Col, Row } from "react-bootstrap";

import {
  BG_JOB_STATUS,
  defaultGridStateModalDataTable,
} from "../../../../constants";
import { DataTableComponent, ProgressBar } from "../../../../shared/components";
import CustomBodyModal from "../../../../shared/components/modal/CustomBodyModal";
import {
  calculateBarWidth,
  formatedDateTime,
  shopifyResetStatusDetailViewColumnHeaders,
} from "../../../../shared/utility";
import { useState } from "react";

//------- reset progress of one store, company reset runs in every connected store
const ResetStoreStatus = ({ storeResetJob }) => {
  const failedProducts = storeResetJob?.failedProducts ?? [];
  const storeMiscData = storeResetJob?.miscData ?? {};
  const [gridState, setGridState] = useState(defaultGridStateModalDataTable);

  return (
    <>
      <Row className="mt-3">
        <Col>
          <p className="my-1 fw-bold">{storeResetJob?.store?.name}</p>
          <ProgressBar
            min={0}
            max={100}
            current={storeMiscData?.progressPercentage || 0}
            percentage={calculateBarWidth(
              100,
              storeMiscData?.progressPercentage || 0
            )}
            label={`${storeMiscData?.progressPercentage || 0}%`}
            barWrapper={true}
          />

          <div className="d-flex flex-column my-3 gap-2">
            <p>
              <span className="fw-bold">Status:</span>{" "}
              {storeMiscData?.status || "N/A"}
            </p>

            {storeMiscData?.completedAt && (
              <p>
                <span className="fw-bold">Completed at:</span>{" "}
                {formatedDateTime(storeMiscData.completedAt)}
              </p>
            )}

            <p>
              <span className="fw-bold">Total Inventory Count:</span>{" "}
              {storeMiscData?.totalInventoryCount ?? "N/A"}
            </p>
          </div>
        </Col>
      </Row>
      {failedProducts.length ? (
        <Row>
          <DataTableComponent
            resizableColumns={false}
            responsive={false}
            className="editable-table"
            columns={shopifyResetStatusDetailViewColumnHeaders()}
            data={failedProducts}
            total={failedProducts.length || 0}
            gridState={gridState}
            setGridState={setGridState}
          />
        </Row>
      ) : (
        <></>
      )}
    </>
  );
};

const ResetStatusDetailViewModal = (props) => {
  const { selectedStatus, handleCloseDetailModal } = props;
  const selectedStoreMiscData = selectedStatus?.miscData ?? {};

  return (
    selectedStatus && (
      <CustomBodyModal
        title="Reset Shopify Details"
        show={!!selectedStatus}
        onHide={handleCloseDetailModal}
        size="lg"
      >
        <Row>
          <Col>
            <p className="my-1 fw-bold">Overall Progress</p>
            <ProgressBar
              min={0}
              max={100}
              current={selectedStoreMiscData?.progressPercentage || 0}
              percentage={calculateBarWidth(
                100,
                selectedStoreMiscData?.progressPercentage || 0
              )}
              label={`${selectedStoreMiscData?.progressPercentage || 0}%`}
              barWrapper={true}
            />

            <div className="d-flex flex-column my-4 gap-2">
              <p>
                <span className="fw-bold">Status:</span>{" "}
                {selectedStoreMiscData?.status || "N/A"}
              </p>
              <p>
                <span className="fw-bold">Started at:</span>{" "}
                {selectedStoreMiscData?.startedAt
                  ? formatedDateTime(selectedStoreMiscData.startedAt)
                  : "N/A"}
              </p>

              {selectedStoreMiscData?.completedAt && (
                <p>
                  <span className="fw-bold">Completed at:</span>{" "}
                  {formatedDateTime(selectedStoreMiscData.completedAt)}
                </p>
              )}

              {selectedStoreMiscData?.scheduleTime &&
                selectedStoreMiscData?.status === BG_JOB_STATUS.PAUSED && (
                  <p>
                    <span className="fw-bold">Schedule Time:</span>{" "}
                    {formatedDateTime(selectedStoreMiscData.scheduleTime)}
                  </p>
                )}

              {selectedStoreMiscData?.lastResumedAt && (
                <p>
                  <span className="fw-bold">Last Resumed at:</span>{" "}
                  {formatedDateTime(selectedStoreMiscData.lastResumedAt)}
                </p>
              )}

              {selectedStoreMiscData?.lastPausedAt && (
                <p>
                  <span className="fw-bold">Last Paused at:</span>{" "}
                  {formatedDateTime(selectedStoreMiscData.lastPausedAt)}
                </p>
              )}

              {selectedStoreMiscData?.terminatedAt && (
                <p>
                  <span className="fw-bold">Terminated at:</span>{" "}
                  {formatedDateTime(selectedStoreMiscData.terminatedAt)}
                </p>
              )}

              <p>
                <span className="fw-bold">Total Inventory Count:</span>{" "}
                {selectedStoreMiscData?.totalInventoryCount ?? "N/A"}
              </p>
            </div>
          </Col>
        </Row>
        {selectedStatus.stores.map((storeResetJob) => (
          <ResetStoreStatus
            key={storeResetJob.store.id}
            storeResetJob={storeResetJob}
          />
        ))}
      </CustomBodyModal>
    )
  );
};

export default ResetStatusDetailViewModal;
